import {Deserializable} from '../deserializable';;
export  class ChuyenGiaoViec implements Deserializable
{
  public id: number;
  public classPK: number;
  public classCode: string;
  public classPKNew: number;
  public tieuDe: string;
  public noiDung: string;
  public staffId: number;
  public created: Date;
  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
